module.exports = __webpack_public_path__ + "models/clouds_abfd8ee3b824a4ad9a3d2a6e96edc213.glb";